<template>
  <v-autocomplete
    v-model="guest"
    :error-messages="errors"
    return-object
    :dense="dense"
    filled
    outlined
    label="Hóspede"
    :items="guests"
    :loading="loading"
    :search-input.sync="searchKeyWord"
    no-filter
    item-text="name"
    item-value="id"
    @change="change"
  >
    <template v-slot:item="{ item }">
      {{ item.id }} - {{ item.name }}
    </template>

    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-title>
          <strong>{{ message }}</strong>
        </v-list-item-title>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import debounce from 'lodash/debounce'
import axios from '@/plugins/axios'

export default {
  props: {
    value: {},
    errors: {},
    product: {
      type: Object,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    guests: [],
    loading: false,
    guest: null,
    searchKeyWord: '',
    message: '',
  }),
  computed: {
    searchWord() {
      return this.searchKeyWord || ''
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.guests = [val]
        this.guest = val
      }
    },
    searchKeyWord(val) {
      this.$emit('key-word', val)
      this.debouncedSearch()
    },
  },
  created() {
    if (this.value) {
      this.guests = [this.value]
      this.guest = this.value
    }

    // cria uma versão com debounce (espera 500ms sem digitação)
    this.debouncedSearch = debounce(this.search, 500)
  },
  methods: {
    change() {
      this.$emit('input', this.guest)
      this.$emit('change', this.guest)
    },
    search() {
      if (!this.searchWord) {
        this.guests = []

        return
      }

      this.loading = true
      this.message = 'Carregando, aguarde...'
      axios
        .get(`helper/get_guests?search=${this.searchWord}`)
        .then(response => {
          this.guests = response.data
          if (this.guests.length === 0) {
            this.message = 'Nenhum registro encontrado.'
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
